import React, { useState } from "react";
import AdminSidebar from '../adminsidebar/AdminSidebar';  // ✅
import AdminNavbar from '../adminnavbar/AdminNavbar';
import '../../../assets/css/admin/AdminLayout.css'; 


const AdminLayout = ({ children, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <AdminSidebar
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
      />

      {/* Main Content */}
      <div
        className={`admin-content-wrapper ${
          !sidebarOpen ? "full-width" : ""
        }`}
      >
        {/* Navbar */}
        <AdminNavbar
          sidebarOpen={sidebarOpen}
          onLogout={onLogout}
          toggleSidebar={toggleSidebar}
        />

        {/* Page Content */}
        <main className="admin-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;